/** URL prefix for draft mobile prototype pages (Sliding Puzzle Quest, Jigsaw Muse). */
export const PROTOTYPE_MOBILE_PREFIX = "/prototype/mobile";
